import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const convertToDataTable = (data: IGetModel[]): IGetModel[] => {
  const dataTableData: IGetModel[] = [];

  if(!data) return dataTableData;

  data.map(d => {
    dataTableData.push(d)
  })

  return dataTableData;
}

const getAllModelsList = async ( ): Promise<IGetModel[]> => {
  const response =  await axiosDefaultApi.get(`/api/Models/GetModels`,);
  return convertToDataTable(response as unknown as IGetModel[]);
};

type QueryFnType = typeof getAllModelsList;

type UseGetAllModelsListOptions = {
  config?: QueryConfig<QueryFnType>;
};

export const useGetAllModelsList = ({ config }: UseGetAllModelsListOptions = {} ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getAllModelsList'],
    queryFn: () => getAllModelsList(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};